export const overlappingTimePeriodError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("OC_OVERLAPPING_TIME_PERIODS");
  return setError({
    state: true,
    messages: messagesArray,
  });
};

export const exceedsVoluntaryOvertimeLimitError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("MY_TIME_EXCEEDS_WEEKLY_VOLUNTARY_OVERTIME_LIMIT");
  return setError({
    state: true,
    messages: messagesArray,
  });
};

export const exceedsWeeklyWorktimeLimitError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("MY_TIME_EXCEEDS_WEEKLY_WORKTIME_LIMIT");
  return setError({
    state: true,
    messages: messagesArray,
  });
};

export const timePeriodNotAppropriateError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("MY_TIME_PERIOD_NOT_APPROPRIATE");
  return setError({
    state: true,
    messages: messagesArray,
  });
};

export const exceedsDailyWorkTimeLimitError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("MY_TIME_EXCEEDS_DAILY_WORKTIME_LIMIT");
  setError({
    state: true,
    messages: messagesArray,
  });
};

export const exceedsStandByIntervallError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("MY_TIME_EXCEEDS_STAND_BY_INTERVALL");
  return setError({
    state: true,
    messages: messagesArray,
  });
};

export const personalLeaveRequiresWorkingTimeError = ({
  error,
  setError,
}: {
  error: { messages: string[] };
  setError: (error: { state: boolean; messages: string[] }) => void;
}) => {
  const messagesArray = error.messages;
  messagesArray.push("MY_TIME_PERSONAL_LEAVE_REQUIRES_WORKING_TIME");
  return setError({
    state: true,
    messages: messagesArray,
  });
};
